import { jsx as _jsx } from "react/jsx-runtime";
export function RightCloseIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M1 1L13 13M1 13L13 1L1 13Z",
      stroke: "black",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}